import * as React from 'react';

import { compose } from 'recompose';

import Imgix from 'js/components/Imgix';

import type { PropsFromMockEnhancer } from 'bundles/teams-v2/utils/withPromotionBanners';
import { withPromoMockBanners } from 'bundles/teams-v2/utils/withPromotionBanners';

export type AffiliateFromCaller = {
  promotionId: string;
};

type Props = PropsFromMockEnhancer;

// This is not a fully productionalized component yet
// Its hinged on mock data. withPromoMockBanners will map that data
const AffiliateLogo = ({ promotionBanners }: Props) => {
  if (!promotionBanners) {
    return null;
  }

  const { logoImage, description } = promotionBanners;
  const logoHeight = 32;
  return <Imgix src={logoImage || ''} maxHeight={logoHeight} alt={description} />;
};

export default compose<Props, AffiliateFromCaller>(withPromoMockBanners)(AffiliateLogo);
